<template>
  <div class="us_app">
    <div class="new-main">
      <div class="new-inner">
        <div class="lay_left">
          <div class="lay_contents">
            <section class="user_section">
              <article class="view intro slide_wrap">
                <div class="main_slide">
                  <swiper
                    class="swiper mySwiper swiper-wrapper"
                    :options="swiperOption"
                    :navigation="true"
                    ref="mainSwiper"
                  >
                    <swiper-slide v-for="(item, idx) in imagesList" :key="idx">
                      <div class="img_box">
                        <img :src="item.img" alt="" />
                      </div>
                    </swiper-slide>
                  </swiper>
                  <div class="swiper-pagination"></div>
                  <div class="control_wrap">
                    <div class="swiper-prev" slot="button-prev">
                      <b-icon icon="chevron-left"></b-icon>
                    </div>
                    <div class="swiper-next" slot="button-next">
                      <b-icon icon="chevron-right"></b-icon>
                    </div>
                  </div>
                </div>
              </article>
            </section>
          </div>
        </div>
        <div class="lay_right">
          <ul class="main_list">
            <li
              v-for="(item, idx) in mainItem"
              :key="idx"
              @mouseenter="hoverIndex = idx"
              @mouseleave="hoverIndex = null"
            >
              <router-link :to="item.path">
                <div class="icon_box">
                  <img
                    :src="hoverIndex === idx ? item.hoverImg : item.img"
                    alt=""
                  />
                </div>
                <div class="main-item">
                  <h4>{{ item.title }}</h4>
                  <p style="white-space: pre-wrap">{{ item.desc }}</p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <ul class="side_menu">
        <li v-for="(item, idx) in sideItem" :key="idx">
          <router-link :to="item.path">
            <div class="menu_badge" v-if="item.badge">{{ item.badge }}</div>
            <div class="txt_box">
              <h6>{{ item.title }}</h6>
              <p class="prewrap">{{ item.sub }}</p>
            </div>
            <div class="icon"><img :src="item.img" alt="" /></div>
          </router-link>
        </li>
      </ul>
      <div class="animation_banner">
        <div class="ani_wrap">
          <div class="ani_item">
            <img src="@/assets/img/layout/banner_truck.png" alt="" />
          </div>
          <div class="ani_item">
            <img src="@/assets/img/layout/banner_truck.png" alt="" />
          </div>
        </div>
      </div>
      <div class="new-inner user_section">
        <div class="lay_left">
          <h6 class="fwb m0 mb30">공지사항</h6>
          <div class="table_list">
            <table class="list">
              <colgroup>
                <col width="*" />
                <col width="100" />
              </colgroup>
              <tbody>
                <tr
                  v-for="(item, index) in noticeList"
                  :key="index"
                  @click="fn_move_noticeDetail"
                >
                  <td class="al" style="height: 65px; line-height: 65px">
                    <span class="list_style">{{ item.board_notice_title }}</span>
                  </td>
                  <td>
                    <span>{{ item.reg_dt }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="lay_right">
          <div class="delivery">
            <p>택배 <strong>배송 안내</strong></p>
            <div class="txt_box">
              <div>
                <div class="title">
                  탕전 처방
                  <div class="_badge">당일배송</div>
                </div>
                <p>월 - 금 : 오후 1시 이전 결제 완료 시</p>
                <p>토요일 : 오전 10시 이전 결제 완료 시</p>
              </div>
              <div>
                <div class="title">
                  약속 처방
                  <div class="_badge">당일배송</div>
                </div>
                <p>월 - 금 : 오후 4시 이전 결제 완료 시</p>
                <p>토요일 : 오후 10시 이전 결제 완료 시</p>
              </div>
            </div>
            <div class="icon_box">
              <img src="@/assets/img/layout/banner1.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <a class="kakao_icon" style="width: 80px; height: 80px" />
  </div>
</template>

<script>
import axios from 'axios'
// import { noticeList } from "@/data/admin/BoardList";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {},
  methods: {},
  data() {
    return {
      hoverIndex: null,
      mainItem: [
        {
          title: "탕전 처방",
          desc: "정확하고 깨끗한\n탕전 처방",
          path: "/application",
          img: require("@/assets/img/layout/medicine.png"),
          hoverImg: require("@/assets/img/layout/medicine_on.png"),
        },
        {
          title: "첩약건보",
          desc: "건강보험으로 처방하는\n첩약건보",
          path: "/insurance",
          img: require("@/assets/img/layout/point.png"),
          hoverImg: require("@/assets/img/layout/point_on.png"),
        },

        {
          title: "공진단 처방",
          desc: "맛과 효능이 뛰어난\n공진단",
          path: "/promisGoodsList",
          img: require("@/assets/img/layout/ball.png"),
          hoverImg: require("@/assets/img/layout/ball_on.png"),
        },
        {
          title: "약속 처방",
          desc: "미리 미리 준비하는\n약속 처방",
          path: "/promisGoodsList",
          img: require("@/assets/img/layout/promise.png"),
          hoverImg: require("@/assets/img/layout/promise_on.png"),
        },
        {
          title: "내 포인트",
          desc: "선 결제 시 최대 3%\n포인트 적립",
          path: "#",
          img: require("@/assets/img/layout/history.png"),
          hoverImg: require("@/assets/img/layout/history_on.png"),
        },
      ],
      sideItem: [
        {
          title: "처방 내역 및 배송조회",
          sub: "탕전, 환산제, 첩약 처방 내역과\n배송 정보를 알려드립니다.",
          path: "#",
          img: require("@/assets/img/icon/icon_menu1.png"),
        },
        {
          title: "원외탕전 신고하기",
          sub: "원외탕전 서류 접수를\n도와 드립니다.",
          path: "/osdReport",
          img: require("@/assets/img/icon/icon_menu2.png"),
        },
        {
          title: "개인처방관리",
          sub: "사전처방과 등록관리를\n안내 드립니다.",
          path: "#",
          img: require("@/assets/img/icon/icon_menu3.png"),
        },
        {
          badge: "공동탕전실",
          title: "탕전실 시스템 안내",
          sub: "조제탕전시스템 및 위생관리\n시스템 안내",
          path: "#",
          img: require("@/assets/img/icon/icon_menu_arrow.png"),
        },
      ],
      noticeList: [],
      swiperOption: {
        effect: "slide",
        spaceBetween: 10,
        allowTouchMove: false,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets",
        },
        loop: true,
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev",
        },
        breakpoints: {
          1920: {
            loopedSlides: 6,
          },
          1024: {
            loopedSlides: 5,
          },
          768: {
            loopedSlides: 3.5,
          },
          480: {
            loopedSlides: 2.5,
          },
        },
      },
      imagesList: [
        { img: require("@/assets/img/layout/main01.jpg") },
        { img: require("@/assets/img/layout/main02.jpg") },
      ],
    };
  },
  mounted(){
    this.fn_search_notice();
  },
  methods : {
        fn_search_notice(){
            axios
                .post("/api/user/board/getMainNotice")
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.noticeList = res.data.mainNotice;

                    console.log("@@@@ noticeList : %o",this.noticeList);                  

                })
                .catch((err) => console.log(err));
        },
        fn_move_noticeDetail(){
          //this.$router.push('UserNoticeDetail')
        }
    }
};
</script>
